<div class="lum-modal">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">{{
      mode === 'Create' ? 'Create SKU' : 'Update SKU'
    }}</span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>
  <div class="lum-modal__body">
    <div *ngIf="uploadErrors.length > 0" class="tab-errors_-wrapper mb-4">
      <ul>
        <li *ngFor="let error of uploadErrors">
          <span class="text-red-600">{{ error.file?.file.name }}</span>
        </li>
      </ul>
    </div>
    <!-- Tabs -->
    <mat-tab-group
      class="tab-list lum-mat-tab-group"
      dynamicHeight
      mat-stretch-tabs="true"
      (selectedTabChange)="selectedTab($event)"
      #tabGroup
    >
      <mat-tab
        label=""
        class="tab-item"
        [ngClass]="{ active: tab === tabEnums.PRODUCT_INFO }"
      >
        <ng-template mat-tab-label>
          <div class="tab-item__content">
            <span class="tab-label">{{ tabEnums.PRODUCT_INFO }}</span>
          </div>
        </ng-template>
        <lum-rfq-product-information-form
          [form]="form"
          [dialogData]="data"
          [productTypes]="productTypes"
          [productCategories]="categories$ | async"
          [factories]="factories$ | async"
          [unitClasses]="unitClasses$ | async"
          [unitMeasures]="unitMeasures$ | async"
          class="tab-item__container"
        ></lum-rfq-product-information-form>
      </mat-tab>
      <mat-tab
        *ngIf="typeControl.value === 'KIT'"
        label=""
        class="tab-item"
        [ngClass]="{ active: tab === tabEnums.KIT_ITEMS }"
      >
        <ng-template mat-tab-label>
          <div class="tab-item__content">
            <span class="tab-label">{{ tabEnums.KIT_ITEMS }}</span>
          </div>
        </ng-template>
        <lum-rfq-kit-items-form
          [form]="form"
          [dialogData]="data"
          [unitMeasures]="unitMeasures$ | async"
          class="tab-item__container"
        ></lum-rfq-kit-items-form>
      </mat-tab>
      <mat-tab
        label=""
        class="tab-item"
        [ngClass]="{ active: tab === tabEnums.ATTACHMENTS }"
      >
        <ng-template mat-tab-label>
          <div class="tab-item__content">
            <span class="tab-label">{{ tabEnums.ATTACHMENTS }}</span>
          </div>
        </ng-template>
        <lum-rfq-attachments-form
          [form]="form"
          class="tab-item__container"
        ></lum-rfq-attachments-form>
      </mat-tab>
      <mat-tab
        label=""
        class="tab-item"
        [ngClass]="{ active: tab === tabEnums.SHIPPING_PACKING }"
      >
        <ng-template mat-tab-label>
          <div class="tab-item__content">
            <span class="tab-label">{{ tabEnums.SHIPPING_PACKING }}</span>
          </div>
        </ng-template>
        <lum-rfq-shipping-packing-form
          [form]="form"
          class="tab-item__container"
        ></lum-rfq-shipping-packing-form>
      </mat-tab>
      <mat-tab
        *ngIf="!customFieldsEnabled"
        label=""
        class="tab-item"
        [ngClass]="{ active: tab === tabEnums.OTHERS }"
      >
        <ng-template mat-tab-label>
          <div class="tab-item__content">
            <span class="tab-label">{{ tabEnums.OTHERS }}</span>
          </div>
        </ng-template>
        <lum-rfq-other-details-form
          [form]="form"
          class="tab-item__container"
        ></lum-rfq-other-details-form>
      </mat-tab>
      <mat-tab
        *ngIf="customFieldsEnabled"
        label=""
        class="tab-item"
        [ngClass]="{ active: tab === tabEnums.CUSTOM_FIELDS }"
      >
        <ng-template mat-tab-label>
          <div class="tab-item__content">
            <span class="tab-label">{{ tabEnums.CUSTOM_FIELDS }}</span>
          </div>
        </ng-template>
        <ng-template #customFieldContainerRef></ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class="lum-modal__footer mt-4 w-p100" mat-dialog-actions>
    <div class="flex ml-auto lum-modal__action">
      <button
        type="button"
        class="lum-button lum-button--secondary mr-2"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          icon="close"
          color="#5563D6"
          width="16"
          height="16"
        ></lum-ui-icon>
        Close
      </button>

      <lum-ui-button
        [disabled]="(submittingForm$ | async) || isUploading || false"
        [loading]="(submittingForm$ | async) || isUploading || false"
        (clickEvent)="onSubmit()"
      >
        <lum-ui-icon
          class="mr-2.5"
          icon="files"
          color="#ffffff"
          width="16"
          height="16"
        ></lum-ui-icon>
        Create New SKU
      </lum-ui-button>
    </div>
  </div>
</div>
